export default __webpack_public_path__ + "static/media/product-5.d6cb18fc.webp";